export const PARTS_DIAGRAM_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250203-12cd6-c89fd',
  alt: 'Parts Diagram'
};
export const PART_DIAGRAM_LIST_LIMIT = 4;
export const MAINTAINCE_REPAIR_LIMIT_DESKTOP = 5;
export const MAINTAINCE_REPAIR_LIMIT_MOBILE = 3;
export const KIT_TYPE_PMKIT = 'pmkit';
export const KIT_TYPE_SSRO = 'SSRO';

export const QUICK_ACTIONS_SCHEMA = {
  SHOP_PARTS: 'SHOP_PARTS',
  CAT_PARTS_DIAGRAM: 'CAT_PARTS_DIAGRAM',
  REQUEST_SERVICE: 'REQUEST_SERVICE',
  ALP_MAINTENANCE_REPAIRS: 'ALP_MAINTENANCE_REPAIRS',
  MANUALS_AND_RESOURCES: 'MANUALS_AND_RESOURCES',
  MORE: 'MORE'
};

export const PAGE_BREAKPOINTS = {
  XL: 1200,
  LG: 960,
  MD: 768
};

export const CATEGORIES_PREVIEW_COUNT_TABLET = 6;
export const CATEGORIES_PREVIEW_COUNT_MOBILE = 4;

export const CATEGORY_URL = 'category';
export const categoriesListMock = [
  {
    name: 'Ground Engaging Tools',
    identifier: 'GROUND-ENGAGING-TOOLS',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-52df1-a867e',
    seoURL: '/en/wagnerequipment/get',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Drivetrain',
    identifier: 'DRIVE-TRAIN',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-1b650-344b7',
    seoURL: '/en/wagnerequipment/drive-train',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Electrical & Electronics',
    identifier: 'ELECTRICAL-ELECTRONICS',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-9e2f8-c8c38',
    seoURL: '/en/wagnerequipment/electrical-electronics',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Hydralics',
    identifier: 'HYDRAULIC',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-7f918-c44be',
    seoURL: '/en/wagnerequipment/hydralics',
    seoUrlKeyword: 'get'
  }
];

export const filteredCategoriesMock = [
  {
    name: 'Drivetrain',
    identifier: 'DRIVE-TRAIN',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-1b650-344b7',
    seoURL: '/en/wagnerequipment/drive-train',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Electrical & Electronics',
    identifier: 'ELECTRICAL-ELECTRONICS',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-9e2f8-c8c38',
    seoURL: '/en/wagnerequipment/electrical-electronics',
    seoUrlKeyword: 'get'
  }
];

export const notRelatedCategorisMock =
  'MACHINE-ATTACHMENTS|CAB|GROUND-ENGAGING-TOOLS|HYDRAULIC|STRUCTURES-OTH-SYS-COMPONENTS|UC';

export const EQUIPMENT_GROUP_ET = 'ET';

export const PARTS_DIAGRAM_SYSTEM = 'partsDiagramSystem';

export const KITS_PREVIEW_COUNT_DESKTOP = 10;

export const KITS_PREVIEW_COUNT_MOBILE = 5;

export const NO_PM_KITS_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20241113-a1121-3a358',
  alt: 'No-Kits-Image'
};

export const SERVICE_RECOMMENDATION_STATE = {
  NEW_STATE: 'new',
  SEEN_STATE: 'seen'
};

export const NO_CVA_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240717-fd8a9-97514',
  alt: 'No Customer Value Agreements Available'
};

export const CVA_LEARN_MORE_URL =
  'https://www.cat.com/{0}/support/maintenance/customer-value-agreements.html';

export const CVA_DEFAULT_LOCALE = 'en_US';

export const CVA_SPECIFIC_SUPPORTED_LANGUAGES = [
  'ar_SA',
  'de_DE',
  'en_AU',
  'en_GB',
  'en_ID',
  'en_IN',
  'en_MX',
  'en_US',
  'en_ZA',
  'es_ES',
  'es_MX',
  'es_US',
  'fr_DZ',
  'fr_FR',
  'fr_US',
  'id_ID',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'nl_NL',
  'pl_PL',
  'pt_BR',
  'ru_RU',
  'sv_SE',
  'tr_TR',
  'zh_CN',
  'zh_TW',
  'zh_ZA'
];

export const CATSAS_ALP_DIY_VIDEOS_ESPOT = 'CATSAS_ALP_DIY_VIDEOS_ESPOT';

const PRIMARY_GA_EVENT_CTA = 'e_primaryCTA';

export const ADDTOCART_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'Add to cart bestsellers section',
  BUTTON_EVENT_NAME: 'Add to Cart'
};

export const CONTACT_DEALER_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'Contact Dealer bestsellers section',
  BUTTON_EVENT_NAME: 'View all Parts'
};

export const VIEWREPLACEMENT_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'request information bestsellers section',
  BUTTON_EVENT_NAME: 'Request Information'
};
export const BEST_SELLERS_VIEW_ITEM_LIST = {
  item_list_id: 'PCC ALP TOP SELLING PARTS CATEGORY',
  item_list_name: 'PCC ALP TOP SELLING PARTS CATEGORY'
};

export const BEST_SELLERS_GA_EVENT = {
  addToCartCTA: {
    gaprimaryCTA: ADDTOCART_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: ADDTOCART_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: ADDTOCART_GAEVENTS.CONTEXT
  },
  contactDealerCTA: {
    gaprimaryCTA: CONTACT_DEALER_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: CONTACT_DEALER_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: CONTACT_DEALER_GAEVENTS.CONTEXT
  },
  viewReplacementCTA: {
    gaprimaryCTA: VIEWREPLACEMENT_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: VIEWREPLACEMENT_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: VIEWREPLACEMENT_GAEVENTS.CONTEXT
  },
  listNameAndId: 'PCC ALP TOP SELLING PARTS CATEGORY',
  gaEventFormLocation: 'PCC ALP TOP SELLING PARTS CATEGORY'
};

export const CUSTOMER_VALUE_AGREEMENTS_GA = {
  contentName: 'customer value agreements',
  contentType: 'content',
  contentLocation: 'body'
};

export const LEARN_MORE_GA = {
  dataEvent: 'e_primaryCTA',
  dataAttributeText: 'customer value agreeements section',
  dataAttributeContext: 'learn more'
};

export const OMM_BOOK_META = {
  sampleImageUrl: 'SampleImageUrl',
  pattern: /(https:\/\/.*\/)/gm
};

export const MANUALS_RESOURCES_LIST_LIMIT = 6;
